import React from 'react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Badge } from '@/components/ui/badge'
import { CheckCircle2, Clock, ShieldCheck, Upload } from 'lucide-react'

export default function CustomerDataPage() {
  const milestones = [
    { title: 'Secure import from Jobber + CRM', timing: 'In QA', icon: Upload },
    { title: 'Unified customer timeline', timing: 'Next sprint', icon: Clock },
    { title: 'Exports & reporting', timing: 'Planned', icon: ShieldCheck }
  ]

  return (
    <div className="space-y-6">
      <div className="flex flex-col gap-3 md:flex-row md:items-start md:justify-between">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Customer Data</h1>
          <p className="text-muted-foreground max-w-2xl">
            A consolidated customer record is in progress. We are finishing ingestion from Jobber and CRM sources,
            plus a timeline view of requests, jobs, and reviews.
          </p>
        </div>
        <Button variant="secondary" size="sm" className="self-start">
          Notify me when ready
        </Button>
      </div>

      <Card className="border-dashed">
        <CardHeader>
          <div className="flex items-center gap-2">
            <Badge variant="secondary">Building</Badge>
            <CardTitle>What to expect</CardTitle>
          </div>
          <CardDescription>
            We are sequencing work so this launches with real data and permissioning on day one.
          </CardDescription>
        </CardHeader>
        <CardContent className="grid gap-4 md:grid-cols-3">
          {milestones.map(({ title, timing, icon: Icon }) => (
            <div key={title} className="p-3 rounded-lg border bg-muted/30">
              <div className="flex items-center gap-2">
                <Icon className="w-4 h-4 text-primary" />
                <span className="text-sm font-medium">{title}</span>
              </div>
              <p className="text-xs text-muted-foreground mt-1">Status: {timing}</p>
            </div>
          ))}
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Early access + requirements</CardTitle>
          <CardDescription>We can enable a beta once the following are in place:</CardDescription>
        </CardHeader>
        <CardContent className="space-y-2 text-sm text-muted-foreground">
          <div className="flex items-center gap-2">
            <CheckCircle2 className="w-4 h-4 text-success" />
            Verified Jobber connection with customer + job scopes
          </div>
          <div className="flex items-center gap-2">
            <CheckCircle2 className="w-4 h-4 text-success" />
            Data retention + export policy signed off
          </div>
          <div className="flex items-center gap-2">
            <CheckCircle2 className="w-4 h-4 text-success" />
            Role-based access rules aligned with Admin/Manager roles
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
